import PracticePatientForm from "../components/PatientExperience/PracticePatientForm";
import ThereMore from "../components/PatientExperience/ThereMore";
import { HeaderUser } from "../components/HeaderUser";
import { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { toGetDetailAssessment } from "../utils/APIs";
import ScreenLoader from "../components/ScreenLoader";
import { FormattedMessage } from "react-intl";
import FirstBlock from "../components/PatientExperience/FirstBlock";
import ThirdBlock from "../components/PatientExperience/ThirdBlock";
import FourthBlock from "../components/PatientExperience/FourthBlock";
import FifthBlock from "../components/PatientExperience/FifthBlock";
import SixthBlock from "../components/PatientExperience/SixthBlock";
import Reference from "../components/PatientExperience/Reference";
import ToolStore from "../DataStores/ToolStore";

const ChartPage = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const [assessment, setAssessment] = useState(null);

  const [id, setId] = useState(null != location.state ? location.state.id : -1);

  useEffect(() => {
    if (null == id || id == -1) {
      navigate("/");
    }
    toGetDetailAssessment(id).then((res) => {
      setAssessment(res);
    });
  }, []);

  return (
    <>
      <HeaderUser display={true} />

      <div
        style={{
          backgroundColor: "#f5f7fa",
          width: "100%",
          paddingTop: "3vh",
          height: "fit-content",
        }}
      >
        {assessment ? (
          <div>
            <div className="roi--patient-exp-acq-container">
              <div className="roi--patient-exp-acq-title">
                <span>
                  <FormattedMessage id="Patienexperienceandacquisition" />
                </span>
              </div>
              <FirstBlock
                happyPatient={assessment?.calculatedValues?.happyPatient}
                percentageDmPatient={
                  assessment?.calculatedValues?.percentageDmPatient
                }
              />
              {/* <SecondBlock /> */}
            </div>
            <div className="roi--patient-exp-acq-container">
              <div className="roi--patient-exp-acq-title">
                <span>
                  <FormattedMessage id="potentialPatientFeedback" />
                </span>
              </div>

              <ThirdBlock
                practiceEfficiency={
                  assessment?.calculatedValues?.practiceEfficiency
                }
              />
              <FourthBlock
                potentialImpact={assessment?.calculatedValues?.potentialImpact}
              />
              <FifthBlock timeSaved={assessment?.calculatedValues?.timeSaved} />
              <SixthBlock
                countryId={assessment?.countryId}
                symbol={assessment?.symbol}
                revenue={assessment?.calculatedValues?.revenue}
              />

              <Reference />
            </div>
            <ThereMore result={assessment?.calculatedValues} />
            <PracticePatientForm selected={assessment} ToolStore={ToolStore} />
          </div>
        ) : (
          <ScreenLoader />
        )}
      </div>
    </>
  );
};

export default ChartPage;
